import React from "react";
import PropTypes from "prop-types";
import styles from "./PasswordChangeHelperText.module.scss";
import { StatusLockedIcon } from "../../components/Icon";

const PasswordChangeHelperText = ({
  text
}) => /*#__PURE__*/React.createElement("div", {
  className: styles.container
}, /*#__PURE__*/React.createElement(StatusLockedIcon, {
  className: styles.image
}), /*#__PURE__*/React.createElement("div", {
  className: styles.text,
  dangerouslySetInnerHTML: {
    __html: text
  }
}));

PasswordChangeHelperText.propTypes = {
  text: PropTypes.string.isRequired
};
export default PasswordChangeHelperText;